import { useMutation, useQuery } from '@tanstack/react-query';

import { EQueryKeys } from '../constants/enums';
import useAxios from '../hooks/useAxios';

import { EApiRoutes, fetchConfig, getApiRouteOrMock } from './api.utils';
import {
  ReceiptThemeResponse,
  ReceiptThemeFormValues
} from 'components/Theme/ReceiptTheme/types';

export default function useReceiptsTheme(currentPublisherId?: string) {
  const axios = useAxios();

  const getReceiptTheme = useQuery<ReceiptThemeResponse, Error>({
    ...fetchConfig.general,
    retry: false,
    queryKey: [EQueryKeys.RECEIPT_THEME + (currentPublisherId ?? '')],
    queryFn: async () =>
      await axios.get(
        getApiRouteOrMock(EApiRoutes.RECEIPT_THEME),
        {},
        currentPublisherId ? { 'x-publishers': currentPublisherId } : undefined
      ),
    enabled: !!currentPublisherId
  });

  const upsertReceiptTheme = useMutation(
    async (receiptTheme: Partial<ReceiptThemeFormValues>) => {
      return await axios.put(
        getApiRouteOrMock(EApiRoutes.RECEIPT_THEME),
        { receiptTheme },
        currentPublisherId ? { 'x-publishers': currentPublisherId } : undefined
      );
    },
    {}
  );

  return { getReceiptTheme, upsertReceiptTheme };
}
